import http from "@/apis/http";
import url from "@/config/url";

const accounts = url.accounts;

export default {
  paper: {
    getData: (params) => http.post(accounts.paper.search, params),
    getColumns: (params) => http.post(accounts.paper.columns, params),
    bet: {
      getColumns: (params) => http.post(accounts.paper.bet.columns, params),
      getData: (params) => http.post(accounts.paper.bet.search, params),
    },
  },
  history: {
    getData: (params) => http.post(accounts.history.search, params),
    getColumns: (params) => http.post(accounts.history.columns, params),
    getMemberExport: (params) => http.post(accounts.history.export, params),
    getSelection: (params) => http.post(accounts.history.selection, params),
    getAllLevelsExport: (params) =>
      http.post(accounts.history.all_levels, params),
  },
  bet: {
    getData: (params) => http.post(accounts.bet.search, params),
    getColumns: (params) => http.post(accounts.bet.columns, params),
  },
  reward: {
    getData: (params) => http.post(accounts.reward.search, params),
    getColumns: (params) => http.post(accounts.reward.columns, params),
  },
  reward_info: {
    getData: (params) => http.post(accounts.reward_info.search, params),
    getColumns: (params) => http.post(accounts.reward_info.columns, params),
  },
  contribution: {
    getData: (params) => http.post(accounts.contribution.search, params),
    getColumns: (params) => http.post(accounts.contribution.columns, params),
  },
  income: {
    getData: (params) => http.post(accounts.income.search, params),
    detail: {
      getData: (params) => http.post(accounts.income.detail.search, params),
      getColumns: (params) => http.post(accounts.income.detail.columns, params),
    },
  },
  transfer: {
    getData: (params) => http.post(accounts.transfer.search, params),
    getColumns: (params) => http.post(accounts.transfer.columns, params),
  },
  finance: {
    getData: (params) => http.post(accounts.finance.search, params),
    getColumns: (params) => http.post(accounts.finance.columns, params),
  },
  return_bonus: {
    getData: (params) => http.post(accounts.return_bonus.search, params),
    getColumns: (params) => http.post(accounts.return_bonus.columns, params),
    getExport: (params) => http.post(accounts.return_bonus.export, params),
  },
  profit: {
    getData: (params) => http.post(accounts.profit.search, params),
    getColumns: (params) => http.post(accounts.profit.columns, params),
    getDetail: (params) => http.post(accounts.profit.detail, params),
  },
  public: {
    getBetDefaultOptions: (params) =>
      http.post(accounts.public.bet_default_options, params),
    getProfitDefaultOptions: (params) =>
      http.post(accounts.public.profit_default_options, params),
  },
  statistic: {
    getEarningsStatisticExport: (params) =>
      http.post(url.statistic.export, params),
  },
  high_profit_members: {
    getData: (params) => http.post(accounts.high_profit_members.search, params),
    getColumns: (params) =>
      http.post(accounts.high_profit_members.columns, params),
  },
  member_monthly_profit: {
    getData: (params) =>
      http.post(accounts.member_monthly_profit.search, params),
    getColumns: (params) =>
      http.post(accounts.member_monthly_profit.columns, params),
    getDetail: (params) =>
      http.post(accounts.member_monthly_profit.detail, params),
  },
};
